import React from 'react';
import { FC } from 'react';
import styled from 'styled-components';

const Content: FC<{ className?: string }> = () => (
    <svg width='128' height='129' viewBox='0 0 128 129' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g filter='url(#filter0_d_33_638)'>
            <path d='M10.3052 22.604L3.97867 29.1787H16.6316L10.3052 22.604Z' fill='#1500FF' />
        </g>
        <g filter='url(#filter1_d_33_638)'>
            <path d='M105.273 117.572L98.6983 111.245L98.6983 123.898L105.273 117.572Z' fill='#1500FF' />
        </g>
        <g filter='url(#filter2_d_33_638)'>
            <path
                d='M57.3721 25.1468C55.8583 23.5409 53.7483 22.6317 51.5414 22.6342L9.68594 22.6832L105.193 118.19V79.0532C105.193 77.0132 104.414 75.0502 103.014 73.5657L57.3721 25.1468Z'
                fill='url(#paint0_linear_33_638)'
            />
        </g>
        <path
            d='M48.2938 47.2116L56.5219 38.9834L59.8164 42.2779C60.4217 42.8832 60.8369 43.4778 61.0619 44.0617C61.2869 44.6456 61.3418 45.1987 61.2266 45.721C61.1141 46.2407 60.8516 46.7067 60.4392 47.1192C60.1177 47.4406 59.7709 47.6589 59.3986 47.7741C59.029 47.8866 58.654 47.908 58.2736 47.8383C57.8987 47.7687 57.5357 47.6227 57.1849 47.4004L57.1045 47.4808C57.4045 47.8075 57.6094 48.1892 57.7192 48.6258C57.8317 49.0651 57.8263 49.5177 57.7031 49.9838C57.5826 50.4471 57.3201 50.881 56.9157 51.2855C56.4791 51.7221 55.9809 52.0033 55.4211 52.1292C54.8667 52.2551 54.2801 52.2069 53.6614 51.9846C53.0427 51.7622 52.4253 51.3431 51.8092 50.727L48.2938 47.2116ZM51.4557 47.529L52.8739 48.9472C53.3587 49.432 53.8047 49.6932 54.2118 49.7307C54.6216 49.7655 54.9818 49.6275 55.2925 49.3168C55.5202 49.0892 55.6662 48.8334 55.7305 48.5495C55.7948 48.2656 55.7747 47.9723 55.6702 47.6696C55.5684 47.3696 55.3783 47.0803 55.0997 46.8018L53.6413 45.3434L51.4557 47.529ZM54.8185 44.1662L56.1081 45.4559C56.3465 45.6943 56.5996 45.8643 56.8675 45.9661C57.1407 46.0679 57.4085 46.0947 57.671 46.0465C57.9362 46.0009 58.1772 45.8697 58.3942 45.6527C58.6915 45.3554 58.8254 45.0099 58.7959 44.6162C58.7692 44.2251 58.5629 43.8368 58.1772 43.4511L56.8554 42.1293L54.8185 44.1662ZM55.7737 54.6915L64.0018 46.4633L69.5462 52.0077L68.1119 53.442L64.3072 49.6372L62.3465 51.5979L65.866 55.1173L64.4317 56.5516L60.9122 53.0322L58.9476 54.9968L62.7684 58.8176L61.3341 60.2519L55.7737 54.6915ZM69.1816 54.5117L70.6159 53.0774L77.3736 59.835L75.9393 61.2694L73.4202 58.7503L66.6263 65.5441L64.9068 63.8246L71.7006 57.0307L69.1816 54.5117ZM70.6711 69.5889L68.8069 67.7247L79.8756 62.337L82.1174 64.5789L76.7257 75.6435L74.8615 73.7793L79.1484 65.3704L79.0841 65.3061L70.6711 69.5889ZM73.7888 66.2382L78.1922 70.6415L76.8342 71.9995L72.4308 67.5961L73.7888 66.2382Z'
            fill='white'
        />
        <defs>
            <filter
                id='filter0_d_33_638'
                x='0.478516'
                y='18.104'
                width='19.6533'
                height='13.5747'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='-1' />
                <feGaussianBlur stdDeviation='1.75' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_33_638' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_33_638' result='shape' />
            </filter>
            <filter
                id='filter1_d_33_638'
                x='95.1982'
                y='106.745'
                width='13.5747'
                height='19.6533'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='-1' />
                <feGaussianBlur stdDeviation='1.75' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_33_638' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_33_638' result='shape' />
            </filter>
            <filter
                id='filter2_d_33_638'
                x='2.88603'
                y='19.8343'
                width='109.107'
                height='109.156'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='3.4' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_33_638' />
                <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_33_638' result='shape' />
            </filter>
            <linearGradient id='paint0_linear_33_638' x1='73.9999' y1='90.8682' x2='107.652' y2='34.5603' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#4838FF' />
                <stop offset='1' stopColor='#80A4FF' />
            </linearGradient>
        </defs>
    </svg>
);

export const BetaBannerIcon = styled(Content)``;
